import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {playistEndpoint} from '../_constants/api.constant'
export async function reorderSongsInPlaylist(userId,playlistId,dataObj) {
    const response = await axios.put(
        playistEndpoint.SONG_REORDER_INPLAYLIST+'?userId='+userId+'&playlistId='+playlistId,
        // playistEndpoint.SONG_REORDER_INPLAYLIST+playlistId,
        dataObj,
        {   
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}